<template>
  <div class="micro-unique">
    <div class="value">{{ totalUnique }}</div>
    <div class="label">{{ $t('unique_values') }}</div> 
  </div>
</template>

<script>

export default {
  props: ['data','total'],

  computed:{
    totalUnique(){
      return this.data.count
    }
  }
}
</script>

<style lang="stylus" scoped>
.micro-unique
  display flex
  flex-direction column
  align-items center
  justify-content: center;
  height 100%
  font-weight normal
  .value 
    font-weight bold
    m-font-size(16,24)
  
</style>
